import Component from 'inferno-component';
import { connect } from 'inferno-redux';

import { getWordById } from '../redux/words';
import { getDecks } from '../redux/decks';
import { getCognitoUser } from '../redux/auth';

import AddToDeckHorizontalIcon from '../assets/images/add-to-deck-horizontal-icon';

import AddWordToDeckModal from '../components/AddWordToDeckModal';
import DefinitionPreviewRow from '../components/DefinitionPreviewRow';
import DefinitionRow from '../components/DefinitionRow';
import Page from '../components/Page';

function mapStateToProps(state) {
  return {
    decks: state.decks.items,
    searchResults: state.words.searchResults,
    selectedWord: state.words.selectedWord,
    user: state.auth.userInformation,
    userIsLoggedIn: state.auth.userIsLoggedIn,
  };
}

const initialState = {
  decks: [],
  isLoading: false,
  pageNoScroll: false,
  searchResults: [],
  selectedWord: null,
  showAddToDeckModal: false,
  word: '',
  error: null,
  modalWord: null,
};

class Definition extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    const { params } = this.props;
    window.addEventListener('keydown', this.handleEscPress);
    this.props
      .getCognitoUser()
      .then(user => {
        this.props.getDecks(user.sub).then(decks => {
          this.setState({
            decks,
            isLoading: false,
          });
        });
      })
      .catch(err => {});
    if (params.wordId) {
      return this.props.getWordById(params.wordId).then(selectedWord => {
        this.setState({
          selectedWord,
          modalWord: selectedWord,
          isLoading: false,
        });
      });
    }
  }

  setModalWord = word => {
    if (!this.props.userIsLoggedIn) {
      return this.context.router.push('/flashcards');
    }
    return this.setState({
      modalWord: word,
      pageNoScroll: true,
      showAddToDeckModal: true,
    });
  };

  toggleAddToDeckModal = () => {
    this.props
      .getCognitoUser()
      .then(() => {
        this.setState({
          showAddToDeckModal: !this.state.showAddToDeckModal,
          pageNoScroll: !this.state.showAddToDeckModal,
        });
      })
      .catch(err => {
        this.context.router.push('/flashcards');
      });
  };

  handleEscPress = e => {
    if (e.keyCode === 27 || e.key === 'Escape') {
      this.setState({
        pageNoScroll: false,
        showAddToDeckModal: false,
      });
    }
  };

  render() {
    const { searchResults, selectedWord } = this.props;
    const {
      decks,
      isLoading,
      modalWord,
      pageNoScroll,
      showAddToDeckModal,
    } = this.state;
    return (
      <Page
        showLargeSearchBar={true}
        hideSmallSearchBar={true}
        isLoading={isLoading}
        noScroll={pageNoScroll}
      >
        {showAddToDeckModal && (
          <AddWordToDeckModal
            deckItems={decks}
            toggleAddToDeckModal={this.toggleAddToDeckModal}
            modalWord={modalWord.word}
            wordId={modalWord.id}
          />
        )}

        {
          <ul className="definition-preview-row--container">
            {searchResults.length > 0 &&
              searchResults.map(word => {
                return (
                  <DefinitionPreviewRow
                    word={word}
                    setModalWord={this.setModalWord}
                  />
                );
              })}
          </ul>
        }

        {searchResults.length === 0 &&
          selectedWord.word && (
            <div className="definition__container">
              <div className="definition__header">
                <h2 className="definition__word">{selectedWord.word}
                  {
                    selectedWord.pronunciation &&
                    <span>
                      <audio id="pronunciation-audio" src={selectedWord.pronunciation} />
                      <button className="definition__pronunciation" type="button" onClick={(e)=> {
                        e.stopPropagation();
                        const pronunciationNode = document.getElementById("pronunciation-audio");
                        return pronunciationNode.paused ? pronunciationNode.play() : pronunciationNode.pause();
                      }} />
                    </span>
                  }
                </h2>
                <button
                  className="button--invisible definition__add-to-deck"
                  onClick={this.toggleAddToDeckModal}
                >
                  <AddToDeckHorizontalIcon />
                </button>
              </div>
              {selectedWord.definitions.map((definition, index) => {
                let parsedDefinition = definition;
                parsedDefinition.display = true;
                if (
                  index !== 0 &&
                  parsedDefinition.def_src ===
                    selectedWord.definitions[index - 1].def_src
                ) {
                  parsedDefinition.display = false;
                }
                return <DefinitionRow definition={parsedDefinition} word={selectedWord.word} index={index} />;
              })}
            </div>
          )}
      </Page>
    );
  }
}

export default connect(mapStateToProps, {
  getDecks,
  getCognitoUser,
  getWordById,
})(Definition);



// WEBPACK FOOTER //
// ./src/pages/Definition.js